import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Disable native scroll restoration once, at module load — before any
// route transition happens. Otherwise the browser will try to restore
// the previous scroll position on same-pathname search-param changes
// (e.g. /Explore?search=foo → /Explore), which fights our own explicit
// scroll-to-top calls in the Clear-All and Wishlist flows.
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

/**
 * Scrolls the window to the top on every pathname change so route
 * transitions always start from the top — fixes the "lands mid-page"
 * behaviour the browser otherwise produces when one page is taller
 * than the next, or when "View all" / category-tile / footer links
 * navigate from a scrolled position on the previous route.
 *
 * Listens to `pathname` only — NOT `search` — so within-page filter
 * URL updates on /Explore (e.g. `?category=tours`) don't fight with
 * the page's own filter-change scroll behaviour.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
}

export default ScrollToTop;
